export default {
    Statistics: 'Statistics',
    WeeklySales: 'Weekly Sales',
    Distribution: 'Distribution',
    Adobe: 'Adobe',
    Quarter: 'Quarter',
    Products: 'Products',
    Orders: 'Orders',
    Events: 'Events',
    News: 'News',
    Library: 'Library',
    Settings: 'Settings',
    Countries: 'Countries',
    Users: 'Users',
    Categories: 'Categories',
    Prizes: 'Prizes',
    WonPrizes: 'Won Prizes',
    Markup: 'Markup',
    MarkupGroup: 'Markup Group',
    Targets: 'Targets',
    Groups: 'Groups',
    groups: 'Group',
    View: 'View',

    royalty: 'Royalty',
    dealerPrice: 'Dealer price',
    id: 'ID',
    title: 'Title',
    action: 'Action',
    edit: 'Edit',
    delete: 'Delete',
    parent: 'Parent',
    save: 'Save',
    add: 'Add',
    PriceDetails: 'Price Details',
    total: 'Total',
    NotEnoughMoney: 'Impossible to place order.<br>Order value is greater than remaining credit limit.',
    PLACEORDER: 'PLACE ORDER',
    BrowseProducts: 'Browse Products',
    ExportToExcel: 'Export To Excel',
    image: 'Image',
    startAt: 'Start at',
    endAt: 'End at',
    createdAt: 'Created at',
    start: 'Start',
    end: 'End',
    description: 'Description',
    products: 'Products',
    prizes: 'Prizes',
    confirm: 'Confirm',
    doYouWantToDelete: 'Do You Want To Delete',
    view: 'View',
    more: 'More',
    points: 'Points',
    RecoverYourPassword: 'Recover your password',
    RecoverYourPasswordDesc: 'Please enter your email address and we\'ll send you instructions on how to reset your password.',
    BackToLogin: 'Back To Login',
    password: 'Password',
    ConfirmPassword: 'Confirm Password',
    RecoverPassword: 'Recover Password',
    ChangePassword: 'Change Password',
    ChangeInformation: 'Change Information',
    MyPrizes: 'My Prizes',
    users: 'Users',
    file: 'File',
    OldFile: 'Old File',
    download: 'Download',
    login: 'Login',
    loginDesc: 'Welcome back, please login to your account.',
    RememberMe: 'Remember Me',
    ForgotPassword: 'Forgot Password?',
    SubTitle: 'Sub Title',
    status: 'Status',
    date: 'Date',
    viewAll: 'View All',
    fromDate: 'From Date',
    toDate: 'To Date',
    searchById: 'Search By Id',
    searchBySku: 'Search By SKU',
    searchByProductName: 'Search By Product Name',
    productName: 'Product Name',
    userGroup: 'User Group',
    sku: 'SKU',
    quantity: 'Quantity',
    quantity_short: 'Q-ty',
    UnitPrice: 'Unit Price',
    price: 'Price',
    ProductName: 'Product Name',
    keys: 'Keys',
    TotalPrice: 'Total Price',
    comment: 'Comment',
    comments: 'Comments',
    DealerName: 'Dealer',
    UserName: 'User Name',
    InStock: 'Available',
    NotInStock: 'Not Available',
    NotEnoughPoint: 'Not Enough Point',
    TakeAPrize: 'Take a Prize',
    count: 'Quantity',
    point: 'Point',
    category: 'Category',
    amount: 'Amount',
    about: 'Personal data',
    CompanyName: 'Company Name',
    voen: 'VÖEN',
    contract_number: 'Contract number',
    contract_start_at: 'Contract start date',
    MPNID: 'MPN ID',
    name: 'Name',
    emailAddress: 'E-Mail Address',
    phone: 'Phone',
    FinCode: 'Fin Code',
    country: 'Country',
    joined: 'Joined',
    OldPassword: 'Old Password',
    NewPassword: 'New Password',
    ConfirmNewPassword: 'Confirm New Password',
    change: 'Change',
    Months: 'Months',
    Sum: 'Sum',
    TargetProgress: 'Target Progress',
    toComplete: 'to complete',
    BestSeller: 'Best Seller',
    Top5Products: '5 Top Products',
    targetDesc: 'After adding a target, you cannot delete or change it.',
    limit: 'Limit',
    spent: 'Spent',
    bonus: 'Bonus',
    photo: 'Photo',
    event: 'Event',
    prize: 'Prize',
    unlimited: 'Make Unlimited?',
    ExportasCSV: 'Export as CSV',
    ConfirmTaken: 'Confirm Taken',
    Taken: 'Taken',
    PartnerStatus: 'Partner Status',
    RemainingCreditLimit: 'Remaining Credit Limit',
    items: 'Items',
    InYourCart: 'In Your Cart',
    checkout: 'Checkout',
    YourCartIsEmpty: 'Your Cart Is Empty.',
    profile: 'Profile',
    logout: 'Logout',
    activate: 'Activate',
    return: 'Return',
    sendByEmail: 'Send by mail',
    sendAllActivatedByEmail: 'Send all activated by email',
    SendToken: 'Send Token',
    note: 'Note',
    returnable: 'Current product is returnable. Please check manual for more info.',
    not_returnable: 'Current product is NOT returnable!',
    addToCart: 'Add to cart',
    remove: 'Remove',
    group: 'Group',
    user: 'User',
    paid: 'Paid',
    paidHistory: 'Paid History',
    soldBy: 'Sold by',
    Brands: 'Brands',
    Clear: 'Clear',
    language: 'Language',
    delivery_time: 'Delivery time',
    operating_systems: 'Operating systems',
    license_type: 'License type',
    users_count: 'Users count',
    devices_count: 'Devices count',
    tab_description: 'Description',
    tab_requirement: 'Requirement',
    tab_installation: 'Installation',
    login_esd_desc: '<b>Techpro DC ESD portal</b><br>This Electronic Software Distribution portal allows you to place orders for software online anytime 24/7. Keys are delivered within 3 minutes since the moment of order.<br><br><br>New users - click on "Become a Partner"',
    login_about: 'About',
    BecomePartner: 'Become a Partner',
    ResetPassword: 'Reset Password',
    PleaseEnterYourNewPassword: 'Please enter your new password',
    FillTheBelowFormToBecomeAPartner: 'Fill the below form to become a partner',
    NameLastname: 'Name, Last name',
    Position: 'Position',
    ContactNumber: 'Contact Number',
    CompanyVOEN: 'Company Tax ID / VAT ID',
    term: 'I accept the <a href="https://esd.techprodc.com/storage/81/muqavile_esd.az.pdf" target="_blank">terms & conditions</a>.',
    excelText1: 'All prices on the portal are shown in USD. At the time when you pay, the payment is made in manats at the USD exchange rate of Pasha Bank.',
    excelText2: 'Prices indicated on the portal do not include VAT',
    dealerPriceText: 'Dealer prices do not include VAT',
    need_azn_cash: 'Need AZN Cash Field?',
    need_azn_credit: 'Need AZN Credit Field?',
    cash: 'Cash',
    credit: 'Credit',
    net_tovara_v_korzine: 'You don\'t have any items in your cart.',
    activateAllKeys: 'Activate all keys',
    need_create_adobe_account: 'Additional information', // Create Adobe account?
    region: 'Region',
    city: 'City',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    postalCode: 'Postal Code',
    marketSegments: 'Market Segments',
    marketSegment: 'Market Segment',
    has_adobe_account: 'Additional information', // Adobe account
    search: 'Search',
    makeAnOrder: 'Make an Order',
    full_name: 'Full Name',
    AdobeCustomer: 'Adobe Customer',
    orderType: 'Order Type',
    getPrice: 'Get Price',
    pricePerOne: 'Price Per One',
    totalPrice: 'Total Price',
    in_progress: 'In Progress',
    pending: 'Pending',
    for_x_days: '{days}',
}
